import React, { memo } from "react";
import { LocationOn, People, Luggage } from "@mui/icons-material";
import { Booking } from "../../../models/booking";
import { dateFormat } from "../common/dateUtils";
import { carColor, statusColor } from "../common/bookingUtils";
import "../../../../styles/commonStyle.css"



interface BookingBasicDetailsProps {
  booking: Booking;
}

const BookingBasicDetails: React.FC<BookingBasicDetailsProps> = ({ booking }) => {

  return (
    <div className="bg-white border rounded shadow-sm p-4 text-start customTextSm" style={{ fontFamily: 'Segoe UI, sans-serif', }}>
      <div className="fw-bold" style={{ fontSize: "1.1rem", color: carColor(booking) }}>
        {booking.fromCity}
        <span className="mx-1">→</span>
        {booking.toCity}
      </div>

      <small className="d-flex mt-0 customTextXs" style={{ color: "#7f8c8d" }}>
        {dateFormat(booking.bookingDate)} | <div className="fw-bold ps-1" style={{ color: statusColor(booking) }}>
          {booking.status === 'NEW' ? 'CONFIRMING' : booking.status}
        </div>
      </small>

      <hr className="my-3" style={{ borderTop: "1px dashed" }} />

      <div className="d-flex align-items-start">
        <div className="d-flex flex-column align-items-center me-3">
          <LocationOn className="text-success" fontSize="small" />
          <div className="border-start border-2" style={{ height: "35px", borderColor: "#ced4da", borderStyle: "dotted" }}></div>
          <LocationOn className="text-danger" fontSize="small" />
        </div>

        <div className="flex-grow-1 overflow-hidden">
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-0 fw-bold" style={{ fontSize: "0.85rem", color: "#495057" }}>Pickup Address</h6>
            </div>
            <p className="mb-0 text-truncate customTextXs" style={{ color: "#6c757d" }}>
              {booking.fromAddress}
            </p>
          </div>

          <div>
            <h6 className="mb-1 fw-bold" style={{ fontSize: "0.85rem", color: "#495057" }}>Drop Address</h6>
            <p className="mb-0 text-truncate customTextXs" style={{ color: "#6c757d" }}>
              {booking.toAddress}
            </p>
          </div>
        </div>
      </div>

      {/* Extra Info Row: Passengers, Big Bags, */}
      <hr className="my-3" style={{ borderTop: "1px dashed" }} />
      <div className="d-flex flex-wrap gap-3 align-items-center">
        {/* Passengers */}
        <div className="d-flex align-items-center gap-2">
          <People fontSize="small" style={{ color: "#17a2b8" }} />
          <span className="customTextXs" style={{ color: "#495057" }}>
            {booking.numberOfPassengers} Passengers
        </span>
        </div>

        {/* Big Bags */}
        <div className="d-flex align-items-center gap-2">
          <Luggage fontSize="small" style={{ color: "#6f42c1" }} />
          <span className="customTextXs" style={{ color: "#495057" }}>
            {booking.numberOfBigBags} Big Bags
       </span>
        </div>


      </div>

    </div>
  );
};


export default memo(BookingBasicDetails);
